/**
 * Auth Helper Utilities
 * Utility functions for auth operations
 */

export const isEmbedded = (): boolean => {
  try { return window.self !== window.top; } catch { return true; }
};

/**
 * Get the stored access token from sessionStorage
 */
export function getStoredAccessToken(): string | null {
  return sessionStorage.getItem('access_token');
}

/**
 * Store access token in sessionStorage
 */
export function storeAccessToken(token: string): void {
  sessionStorage.setItem('access_token', token);
}

/**
 * Clear access token from sessionStorage
 */
export function clearAccessToken(): void {
  sessionStorage.removeItem('access_token');
}

/**
 * Check if user is authenticated based on stored token
 */
export function isAuthTokenValid(): boolean {
  const token = getStoredAccessToken();
  return !!token && token !== 'mock-access-token-for-local-development-12345';
}

/**
 * Extract user claims from JWT token (without verification)
 * Used for quick access to user info stored in token
 */
export function decodeToken(token: string): Record<string, any> {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return {};
    }

    const decoded = JSON.parse(atob(parts[1]));
    return decoded;
  } catch (err) {
    console.error('Failed to decode token:', err);
    return {};
  }
}
